export default __webpack_public_path__ + "static/media/hexagon-challenge-selected.f6ba9d28.svg";